<template>
    <div>
    <div @click.stop="handleClick()">
       <template>
            <span style="display: inline-block;">{{ row.availableBeds }}/{{ row.totalBeds }}</span>
        </template>
    </div>

    <el-dialog v-if="dialogFormVisible" custom-class="box-dialog" :visible.sync="dialogFormVisible" append-to-body="true" width="1000px" height="650px" :close-on-click-modal="false" :close-on-press-escape="false" title="查看宿舍床位情况">
      <div>宿舍名称：{{ rowDetail.dormitoryName }}</div>
    	<el-table :data="tableData" border style="width: 100%">
            <el-table-column type="index" label="序号" align="center"></el-table-column>
            <el-table-column prop="studentId" label="学号" align="center">
                <template slot-scope="scope">
                    <span>{{ scope.row.studentId }}</span>
                </template>
            </el-table-column>
            <el-table-column prop="name" label="名字" align="center">
                <template slot-scope="scope">
                    <span>{{ scope.row.name }}</span>
                </template>
            </el-table-column>
            <el-table-column prop="issueDate" label="性别" align="center">
                 <template slot-scope="scope">
                    <span>{{ scope.row.gender==1?'女':'男' }}</span>
                  </template>
            </el-table-column>
            <el-table-column prop="className" label="班级" align="center">
                <template slot-scope="scope">
                    <span>{{ scope.row.className }}</span>
                </template>
            </el-table-column>
            <el-table-column prop="certificateType" label="床位" align="center">
                <template slot-scope="scope">
                    <span>{{ scope.row.bedNum }}</span>
                </template>
            </el-table-column>
            <el-table-column prop="" label="操作" align="center" width="100">
                <template slot-scope="scope">
                    <el-button type="text" text @click="">退宿</el-button>
                </template>
            </el-table-column>
          </el-table>
    </el-dialog>
    </div>
</template>

<script>
export default {
 	props: {
 	    row: {
 	        type: Object,
 	        default: function () {
 	         return {}
 	       }
 	    }
    },
    data: function() {
        return {
            dialogFormVisible: false,
            tableData: [],
            rowDetail: {}
        }
    },
    computed: {
    },
    watch: {
    },
    created: function() {
    },
    beforeDestroy: function() {
    },
    mounted: function() {
    },
    methods: {
        handleClick() {
            console.log('1111', this.row)
            this.dialogFormVisible = true
            this.rowDetail = {...this.row}
            this.$emit('openBedsInfoDialog', this.row)
        }

    }
}
</script>

<style>
</style>
